export enum AuditLogMethods {
  COUNT = '/audit/count',
  SAVE = '/audit',
  GET = '/audit',
  GET_COMPONENT_LOGS = '/audit/component/logs',
  KEYCLOAK_LOGIN_AUDITS = 'audit/login/logs',
  KEYCLOAK_ADMIN_AUDITS = 'audit/admin/logs',
  KEYCLOAK_ADMIN_AUDITS_COUNT = 'audit/admin/logs/count',
  KEYCLOAK_LOGIN_AUDITS_COUNT = 'audit/login/logs/count',
}

export enum RoleMethods {
  SAVE = '/rbac/role/save',
  COUNT = '/rbac/role/count',
  REMOVE = '/rbac/role/remove',
  EXIST = '/rbac/role/exist',
  GET_NAMES = '/rbac/role/names',
}

export enum GroupMethods {
  SAVE = '/rbac/group/save',
  COUNT = '/rbac/group/count',
  REMOVE = '/rbac/group/remove',
  EXIST = '/rbac/group/exist',
  GET_USERNAMES = '/rbac/group/get-usernames',
  GET_NAMES = '/rbac/group/names',
}

export enum UserMethods {
  GET = '/rbac',
  LOGIN = '/rbac/login',
  UPDATE_TOKEN = '/rbac/update-token',
  SAVE = '/rbac/user/save',
  REMOVE_ONE = '/rbac/user/remove',
  REMOVE_MANY = '/rbac/user/remove-all',
  COUNT = '/rbac/user/count',
  CALCULATE_ROLES = '/rbac/user/calculate-role',
  EXIST = '/rbac/user/exist',
  GET_QR = '/rbac/user/generate-qr',
  GET_USERNAMES = '/rbac/user/get-usernames',
  UPDATE_ATTRIBUTES = '/rbac/update-attributes',
  GET_ATTRIBUTE = '/rbac/get-attributes',
  CHANGE_ACTIVE_RISK_TYPE = '/rbac/change-active-risk-type',
  READ_ERROR_LOGIN_NOTIFICATION = '/rbac/read-error-login-notification',
}

export enum KeycloakUserMethods {
  SETUP_CREATE = '/identity/create-user',
  SETUP_UPDATE = '/identity/update-user',
  LOGIN = '/identity/login',
  LOGOUT = '/identity/logout',
  RESET_PASSWORD = '/identity/reset-password-user',
  PROFILE_UPDATE = '/identity/profile-update-user',
  UPDATE_PREFERENCES = '/rbac/update-preferences',
}

export enum EventMethods {
  SAVE = '/transaction',
  REMOVE = '/transaction',
  DEPLOY = '/transaction/deploy',
  UNDEPLOY = '/transaction/undeploy',
  UNDEPLOY_DEPENDENTS = '/transaction/undeploy-dependents',
  COUNT = '/transaction/count',
  EXIST = '/transaction/exist',
  GET_BY_NAME = '/transaction',
  SEND = '/transaction/send',
  GET_NAMES = '/transaction/names',
  BULK_ACTION = '/transaction/bulk-action',

  GET_HISTORY = '/transaction/history',
  PIN_HISTORY = '/transaction/history/pin',
  DELETE_HISTORY = '/transaction/history',
}

export enum EventVariableMethods {
  REMOVE = '/transaction',
}

export enum ComponentCategoryMethods {
  ADD = '/category/add',
  DELETE = '/category',
  CALCULATE_NON_CATEGORY = '/category/fix',
  FIND_MANY = '/category/find-many',
  ADD_ITEM_TO_CATEGORY = '/category/add-item',
  ADD_CATEGORY_TO_CATEGORY = '/category/add-category',
  DELETE_ITEM_FROM_CATEGORY = '/category/delete-item',
  UPDATE_NAME = '/category/update-name',
  GET_COMPONENT_COUNT_WITH_ACCESS = '/category/count',
}

export enum EnrichmentMethods {
  SAVE = '/enrichment',
  REMOVE = '/enrichment',
  DEPLOY = '/enrichment/deploy',
  UNDEPLOY = '/enrichment/undeploy',
  EXIST = '/enrichment/exist',
  COUNT = '/enrichment/count',
  GET = '/enrichment',
  BULK_ACTION = '/enrichment/bulk-action',
}

export enum ListFileMethods {
  CREATE_COLLECTION = '/list-data',
  GET_COLLECTION_DATA_COUNT = '/list-data/get-data-count',
  ADD_COLLECTION_DATA = '/list-data/add-data',
  IMPORT_COLLECTION_DATA = '/list-data/add-data-bulk',
  REMOVE_COLLECTION_DATA = '/list-data/delete-data',
  REMOVE_BULK_DATA = '/list-data/delete-data-bulk',
  GET_HISTORY = '/list-data/history',
}

export enum ListMethods {
  SAVE = '/list',
  REMOVE = '/list',
  DEPLOY = '/list/deploy',
  UNDEPLOY = '/list/undeploy',
  GET = '/list',
  COUNT = '/list/count',
  EXIST = '/list/exist',
  NAMES = '/list/names',
  BULK_ACTION = '/list/bulk-action',
}

export enum ConnectionMethods {
  SAVE = '/connection',
  REMOVE = '/connection',
  DEPLOY = '/connection/deploy',
  UNDEPLOY = '/connection/undeploy',
  EXIST = '/connection/exist',
  COUNT = '/connection/count',
  TEST_MSSQL_CONNECTION = '/connection/test-mssql',
  BULK_ACTION = '/connection/bulk-action',
}

export enum DashboardMethods {
  SAVE = '/dashboard',
  REMOVE = '/dashboard',
  GET_DASHBOARD = 'dashboard',
  COUNT = 'dashboard/count',
  GET_RULE_PERFORMANCE = 'dashboard/rule-performance',
}

export enum ActionMethods {
  SAVE = '/action',
  REMOVE = '/action',
  DEPLOY = '/action/deploy',
  UNDEPLOY = '/action/undeploy',
  EXIST = '/action/exist',
  COUNT = '/action/count',
  SEND = '/action/send',
  SEND_KYC = '/action/send-kyc',
  BULK_ACTION = '/action/bulk-action',
}

export enum StreamMethods {
  SAVE = '/stream',
  REMOVE = '/stream',
  DEPLOY = '/stream/deploy',
  UNDEPLOY = '/stream/undeploy',
  COUNT = '/stream/count',
  EXIST = '/stream/exist',
  BULK_ACTION = '/stream/bulk-action',
  GET_PERMITTED_STORES = '/stream/permitted-stores',
}

export enum CraMethods {
  SAVE = "/cra",
  REMOVE = "/cra/variable",
  DEPLOY = "/cra/deploy",
  UNDEPLOY = "/cra/undeploy",
  COUNT = "/cra/count",
  EXIST = "/cra/exist",
  GET_PERMITTED_STORES = "/cra/permitted-stores",
  SAVE_VARIABLE = "/cra/variable",
  EXIST_VARIABLE = "/cra/variable/exist",
  CHANGE_VARIABLE_ENABLE = "/cra/variable",
  SEGMENT = "/cra/segment",
  DELETE_SEGMENT = "/cra/segment",
  GET_SEGMENT_BY_VARIABLE_NAME = "/cra/segment",
  GET_ASSESSMENT_RESULTS = "/cra/assessment",
  GET_ASSESSMENT_RESULT_BY_ID = "/cra/assessment",
  COUNT_ASSESSMENT_RESULTS = "/cra/assessment"
}

export enum DataStructureMethods {
  SAVE = '/data-structure',
  REMOVE = '/data-structure',
  GET_BY_ID = '/data-structure/id',
  GET_BY_IDS = '/data-structure/ids',
  EXIST = '/data-structure/exist',
  COUNT = '/data-structure/count',
  GET_ALL = '/data-structure/get-all',
}

export enum AlarmMethods {
  GET_ALARM_COUNT = '/case/get-case-count',
  GET_LOG_COUNT = '/case/get-log-count',
  GET_ACTION_HISTORY = '/case/action-history',
  GO_ALARM = '/case/go',
  GET_NEXT_CASE = '/case/next',
  CLOSE_CASE = '/case/close',
  HOLD_CASE = '/case/hold',

  COMMENT = '/case/comment',
  COMMENT_EDIT = 'case/comment-edit',
  COMMENT_DOMAIN = '/case/comment-domain',
  COMMENT_EDIT_DOMAIN = '/case/comment-edit-domain',
  ATTACHMENT = '/case/attachment',
  ATTACHMENT_DOMAIN = '/case/attachment-domain',
  GET_SCORES = '/case/get-scores',
  GET_DASHBOARD = '/case/dashboard',
  EXECUTE_GRAPH = '/case/graph-execute',
  EXECUTE_SAR = '/case/sar-execute',
  GET_NODE_INFORMATION = '/case/graph-node-information',
  ASSIGN = '/case/assign',
  ASSIGNABLE_USERS = '/case/assignable-users',
  CLOSE_BULK = '/case/close-bulk',
  ACTION_BULK = '/case/action-bulk',
  ERROR_LOG_COUNT = '/case/error-log-count',
  GET_ENRICHMENT_VARIABLE = '/case/get-enrichment-values',
  GET_CASE_COUNTS = '/case/case-counts',
  GET_CASE_PAGE_DATA = '/case/case-get-transactions',
}

export enum EntityMethods {
  GET_DATA = '/entity/get-data',
  UPDATE_NOTE = '/entity/update-note',
  COMMENT = '/entity/comment',
  COMMENT_EDIT = '/entity/comment-edit',
}

export enum AlarmSettingsMethods {
  SAVE = '/case/case-settings/save',
  REMOVE = '/case/case-settings',
  GET_SETTING = '/case/case-settings/get',
  GET_SETTING_BY_CHANNEL = '/case/case-settings/get-by-channel',
  COUNT = '/case/case-settings/count',
}

export enum RuleMethods {
  SAVE = '/rule',
  REMOVE = '/rule',
  DEPLOY = '/rule/deploy',
  COUNT = '/rule/count',
  UNDEPLOY = '/rule/undeploy',
  EXIST = '/rule/exist',
  GET_NAMES = '/rule/get-names',
  BULK_ACTION = '/rule/bulk-action',
  FIND_BY_NAMES = '/rule/find-by-names',
}

export enum TrackerMethods {
  SAVE = '/event-tracker',
  REMOVE = '/event-tracker',
  DEPLOY = '/event-tracker/deploy',
  COUNT = '/event-tracker/count',
  UNDEPLOY = '/event-tracker/undeploy',
  EXIST = '/event-tracker/exist',
  GET_NAMES = '/event-tracker/get-names',
  BULK_ACTION = '/event-tracker/bulk-action',
}

export enum SandboxMethods {
  GET_ELASTIC_HISTORY = 'sandbox/getTransactionsFromElasticSearch',
  SEND_HISTORICAL = '/sandbox/historical',
  TEST_RESULTS = '/sandbox/testResults',
}

export enum JobMethods {
  UNDEPLOY_DEPENDENTS = '/component/undeploy-dependents',
  SCHEDULE = '/component/schedule-job',
  DOWNLOAD = '/component/download-job',
  COUNT = '/component/job-count',
  FIND_MANY = '/component/job-find-many',
  DELETE = '/component/job',
}

export enum MakerCheckerMethods {
  APPROVE = '/maker-checker/approve',
  REJECT = '/maker-checker/reject',
  FIND_MANY = '/maker-checker/find-many',
  FIND_BY_DOC_ID = '/maker-checker/find-one-by-document-id',
}

export enum NotificationMethods {
  READ = '/notification/read',
  READ_ALL = '/notification/read-all',
}

export enum WatchlistMethods {
  SEARCH_MANY = '/watchlist/search-many',
  SEARCH_ONE = '/watchlist/search-many',
  BULK_SCAN = '/watchlist/bulk-scan',
  GET_LISTS = '/watchlist/get-lists',
  GET_KYC_LOG_COUNT = '/watchlist/get-kyc-log-count',
  GO_KYC_LOG = '/watchlist/go-kyc-log',
  CLOSE_KYC_LOG = '/watchlist/close-kyc-log',
  CLOSE_KYC_LOG_BULK = '/watchlist/close-kyc-log-bulk',
  GET_NEWS = '/watchlist/news',
  CUSTOMER_LOOKUP = '/watchlist/customer-lookup',
  SAVE_CONFIGURATION = '/watchlist/save-configuration',
  DELETE_CONFIGURATION = '/watchlist/delete-configuration',
  COMMENT = '/watchlist/comment',
  CONVERT_BASE64 = '/watchlist/convert-base64',
  GET_ALERT_COUNTS = '/watchlist/alert-counts',
  GET_ALERT_PAGE_DATA = '/watchlist/get-alerts',
  ASSIGN_ALERT = '/watchlist/assign-alert',
  SAFE_LIST_ADD = '/watchlist/safe-list/add',
  SAFE_LIST_REMOVE = '/watchlist/safe-list/remove',
  SAFE_LIST_CONFIG = '/watchlist/safe-list/config',
  MATCH_MANY_LOG_COUNT = '/watchlist/match-many-log/count',
  MATCH_MANY_LOG_CONFIG = '/watchlist/match-many-log-config',
}

export enum CustomListMethods {
  CREATE = '/custom-list/create',
  GET_ALL = '/custom-list/get',
  GET_BY_ID = '/custom-list/get',
  GET_LISTS_BY_RECORD = '/custom-list/lists/by-record',
  DELETE = '/custom-list/delete',
  GET_RECORDS_PREFIX = '/custom-list',
}

export enum ChartMethods {
  SAVE = '/chart',
  REMOVE = '/chart',
  DEPLOY = '/chart/deploy',
  UNDEPLOY = '/chart/undeploy',
  EXIST = '/chart/exist',
  COUNT = '/chart/count',
  FAVORITE = '/chart/favorite',
  UNFAVORITE = '/chart/unfavorite',
  SIMULATE = '/chart/simulate',
  EXECUTE = '/chart/execute',
  GET_BY_ID = '/chart',
  GET_SCHEMA_BY_ID = '/chart/schema',
  SIMULATE_FOR_CASE = '/chart/simulate/case',
}

export enum AiModelMethods {
  SAVE = '/ai-model',
  REMOVE = '/ai-model',
  DEPLOY = '/ai-model/deploy',
  UNDEPLOY = '/ai-model/undeploy',
  EXIST = '/ai-model/exist',
  COUNT = '/ai-model/count',
  BULK_ACTION = '/ai-model/bulk-action',
}

export enum AchMethods {
  UPLOAD = '/ach/upload',
  GET = '/ach',
  COUNT = '/ach/count',
  GET_TRANSACTIONS_BY_FILE_NAME = '/ach/transactions',
  EXPORT = '/ach/export',
}